export default __webpack_public_path__ + "static/media/CV_Unlocked.45957d30.png";